import { create as createApp } from './app';
import { logger as createAppLogger } from './logger';

const appLogger = createAppLogger();

export = createApp({
  appLogger,
  userConsole: console,
});
